<div class="level-section">
  <h3>{{ title() | translate }}</h3>
  <div class="level-items">
    @for (item of levelItems(); track item) {
      @if (!levelData().notApplicableItems.includes(item)) {
        <lib-profile-completion-item
          [completed]="isItemCompleted(item, levelData().items)"
          [label]="'profile-score.items.' + item | lowercase | translate"
          [linkLabel]="modalConfigService().getLinkLabel(item) ? (modalConfigService().getLinkLabel(item)! | translate) : undefined"
          (linkClicked)="linkClicked.emit(item)"
        />
      }
    }
  </div>
</div>
